export default function Django_Intro() {
  return <div>Django_Intro Component</div>;
}
